import { ITelemetryLogger } from '@cian/telemetry/shared';

import { EAuthAnalyticsEvents } from '../../constants';

export const sendTelemetry = (eventName: EAuthAnalyticsEvents, telemetry: ITelemetryLogger) => {
  switch (eventName) {
    case EAuthAnalyticsEvents.PhoneScreenShown:
      telemetry.increment(EAuthAnalyticsEvents.PhoneScreenShown);
      break;
    case EAuthAnalyticsEvents.CodeScreenShown:
      telemetry.increment(EAuthAnalyticsEvents.CodeScreenShown);
      break;

    default:
      break;
  }
};
